import { Banner } from '@cargos/sprintpay-ui';

export const TOUNotification: Banner = {
    id: 'tou-products-merge',
    message:
        'We have updated our Terms of Use, please review them <a href="https://cargosprint.com/legal/terms-of-use" target="_blank" rel="noopener noreferrer">here</a>.',
    icon: 'info',
    display: true,
    styleClass: 'info',
    startDate: new Date(2026, 0, 12),
    endDate: new Date(2026, 0, 31),
};

export const allianceFuelSurcharge: Banner = {
    id: 'alliance-fuel-surcharge',
    message: 'Please note that effective immediately, a $2.00 fuel surcharge will be added to each transaction.',
    icon: 'info',
    styleClass: 'info',
    display: true,
    startDate: new Date(2026, 4, 7),
    endDate: new Date(2026, 4, 31),
};

export const choiceHandlingFee: Banner = {
    id: 'choice-handling-fee',
    message:
        'Starting May 1st, a CargoSprint handling fee will apply to payments made using a credit limit/net terms.  Payments made by credit card or eCheck will not be affected and will not incur this fee',
    icon: 'warning',
    styleClass: 'warning',
    display: true,
    startDate: new Date(2026, 3, 16),
    endDate: new Date(2026, 4, 17),
};

export const agiMaintenance: Banner = {
    id: 'agi-maintenance',
    message:
        'We will be undergoing system maintenance on September 12th from 03:00 AM ET to 06:00 AM ET. Please note that during this timeframe the portal will not be available. For assistance, please contact support at <a href="mailto:support@cargosprint.com">support@cargosprint.com</a>',
    icon: 'info',
    styleClass: 'info',
    display: true,
    startDate: new Date(Date.UTC(2026, 8, 2, 4, 0)), // Sep 2, 00:00 AM ET
    endDate: new Date(Date.UTC(2026, 8, 12, 7, 0)), // Sep 12, 03:00 AM ET (maintenance start)
};

export const portalsMaintenance: Banner = {
    id: 'portals-maintenance',
    message:
        'We will be undergoing system maintenance on September 12th from 03:00 AM ET to 06:00 AM ET. Please note that during this timeframe the portal will not be available. For assistance, please contact support at <a href="mailto:support@cargosprint.com">support@cargosprint.com</a>',
    icon: 'info',
    styleClass: 'info',
    display: true,
    startDate: new Date(Date.UTC(2026, 8, 9, 4, 0)), // Sep 9, 00:00 AM ET
    endDate: new Date(Date.UTC(2026, 8, 12, 7, 0)), // Sep 12, 03:00 AM ET (maintenance start)
};
